import React from "react";

// components
import { CustomTable } from "../_commons/CustomTable";
import { Paginator } from "../_commons/Paginator";
import { Filters } from "./LocationsAndMenu";

// constants
import { getColumns } from "./LocationsAndMenu";

const ReviewLocationAssociation = ({
	dsp,
	dspIntegration = {},
	stores,
	handleSearchFilter,
	handleStatusFilter,
	handlePagination,
	handlePageSize,
	handleAssociationUpdates,
	mappedLocations = {},
	editMode = true
}) => {
	const { loading, limit, offset, data, searchFieldValue, appliedFilters, associationUpdates } = dspIntegration;
	return (
		<div className="form-content">
			<Filters
				searchFieldValue={searchFieldValue}
				handleSearchFilter={handleSearchFilter}
				statusFilter={data?.filters?.find((f) => f.field === "store_status") || {}}
				handleStatusFilter={handleStatusFilter}
				statusValue={appliedFilters["store_status"] || null}
			/>
			{data.count > 0 && (
				<div className="locations-status-count">{data.count} Locations found that need to be reviewed</div>
			)}
			<CustomTable
				bordered={true}
				loading={loading}
				data={data?.objects || []}
				columns={getColumns(dsp, editMode)}
				classes="locations-table-container"
				content="locations"
				stores={stores}
				mappedLocations={mappedLocations}
				associationUpdates={associationUpdates}
				handleAssociationUpdates={handleAssociationUpdates}
				hideColumns={["menu", "status"]}
			/>
			<Paginator
				limit={limit}
				offset={offset}
				count={data?.count || 0}
				goToPage={handlePagination}
				setPageSize={handlePageSize}
				showPageSize={true}
			/>
		</div>
	);
};
export default ReviewLocationAssociation;
